import { Gavel } from 'lucide-react';
import type { SourcingEvent } from '../../types';

interface BidsTabProps {readonly event: SourcingEvent;}

export function BidsTab({ event }: BidsTabProps) {
  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: event.currency,
    }).format(amount);

  const hasBids = (event.totalBids ?? 0) > 0;

  if (!hasBids) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <Gavel className="h-12 w-12 text-gray-300 mb-4" />
        <p className="text-lg font-medium text-gray-900">No Bids Yet</p>
        <p className="text-sm text-gray-500">Suppliers have not submitted any bids for this event</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">Submitted Bids ({event.totalBids})</h3>
      </div>
      {event.currentLowestBid && (
        <div className="rounded-lg bg-green-50 border border-green-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-green-700">Current Lowest Bid</p>
              <p className="font-bold text-2xl text-green-600">
                {formatCurrency(event.currentLowestBid)}
              </p>
            </div>
            {event.currentLowestBidder && (
              <div className="text-right">
                <p className="text-sm text-green-700">Leading Supplier</p>
                <p className="font-semibold text-green-800">{event.currentLowestBidder}</p>
              </div>
            )}
          </div>
        </div>
      )}
      <p className="text-sm text-gray-500">
        View detailed bid information in the Bids section of Procurement.
      </p>
    </div>
  );
}
